// extracted by mini-css-extract-plugin
export default {"watchlist-phase-loader":"styles-module__watchlist-phase-loader___KcIx_","message":"styles-module__message___VPgh0","loader":"styles-module__loader___xV5AF"};